import { useState } from 'react'
import { useMutation, useQuery } from "react-query";
import { useLocation } from "react-router-dom";

import axiosInstance from "../../../../api/axiosInstance";
import query from "../../../../api/constants.api";
import { useAuthContext } from "../../../../contexts/AuthContext";
import { useGlobalStateContext } from "../../../../contexts/GlobalStateContext";
import { TReportFormContext } from "../../../../contexts/ReportFormContext";
import { mappedSectionName } from '../../../../utils/constants/categories';
import { TSection } from '../../../../utils/constants/types';

type TUseLocation = {
    state: {
        section: string;
        position: { lat: number, lng: number };
    }
}

const useSubmitForm = () => {
    const { user } = useAuthContext();
    const [submissionNumber, setSubmissionNumber] = useState(0); // To differentiate different form submissions
    const [incidentId, setIncidentId] = useState(null); // To save the new incident id and use on get image api
    const [formData, setFormData] = useState<TReportFormContext['form'] | null>(null); // Save formData to use on image api
    const { globalState: { selectedBusinessId } } = useGlobalStateContext();
    const { state: { section, position: { lat, lng } } } = useLocation() as TUseLocation;

    // 1. Submit form
    //
    const handleSubmitForm = (formData: TReportFormContext['form']) => {
        setFormData(formData);
        setSubmissionNumber(submissionNumber + 1);

        //sends caller_id in the POST request, that fills the task_for in Service Now
        const body = {
            state: "1",
            urgency: formData.severity.value.toString(),
            contact_type: 'app',
            short_description: formData.title.value,
            description: formData.description.value,
            //task_for: user?.sys_id, // user id
            opened_by: user?.sys_id, // user id
            caller_id: user?.sys_id, // user id
            u_category_synergy: formData.dropdown.value.id,
            business_service: selectedBusinessId,
            u_nova_section: mappedSectionName(section as TSection),
            u_longitude: lng,
            u_latitude: lat,
        };

        console.log('body', body);
        console.log('task_for', user?.sys_id);

        return axiosInstance('POST', query.path.incident, body, null, 'application/json');
    };

    const { mutate, isLoading, isError, isSuccess } = useMutation(`form-${submissionNumber}`, handleSubmitForm, {
        onSuccess: (data) => setIncidentId(data?.data?.result?.sys_id),
    });


    // 2. After submitting the form, we use another endpoint to submit the image to update the new created incident
    //
    const handleSubmitImage = () => {
        const body = {
            base64Value: formData?.image.value.base64.replace(/^data:image\/[a-z]+;base64,/, ""),
        };

        const params = {
            table_sys_id: incidentId,
            file_name: formData?.image.value.file.name,
        };

        return axiosInstance('POST', '/v3_0_01/servicenow/incident/attachments', body, params, 'application/json', 'https://okuvoeaz9b.execute-api.eu-west-1.amazonaws.com')
    };

    const { isLoading: isImgLoading, isError: isImgError, isSuccess: isImgSuccess } = useQuery(`uploadImage-${incidentId}`, handleSubmitImage, {
        enabled: incidentId && formData?.image.value.base64? true : false,
        refetchOnWindowFocus: false,
    });

    return { mutate, isLoading: isLoading || isImgLoading, isError: isError || isImgError, isSuccess: isSuccess || isImgSuccess };
}

export default useSubmitForm